import { render, staticRenderFns } from "./permissionsPage.vue?vue&type=template&id=2ea7de05&scoped=true"
import script from "./permissionsPage.vue?vue&type=script&lang=js"
export * from "./permissionsPage.vue?vue&type=script&lang=js"
import style0 from "./permissionsPage.vue?vue&type=style&index=0&id=2ea7de05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7de05",
  null
  
)

export default component.exports